import { createContext, PropsWithChildren, useMemo } from 'react'

import Theme, { ThemeProps } from './theme'

export type Context = ThemeProps & {
  theme: {
    header: {
      variant: 'light' | 'dark'
    }
  }
}

export const ThemeContext = createContext<Context | undefined>(undefined)

const ThemeProvider = ({
  children,
  theme,
  fluid = false
}: PropsWithChildren<Context>) => {
  const contextValue = useMemo(() => ({ fluid, theme }), [fluid, theme])

  return (
    <ThemeContext.Provider value={contextValue}>
      <Theme fluid={fluid} />
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
